"use client";

import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";

export default function PdfModal({
  title = "Document Preview",
  isOpen,
  onClose,
  children,
  pdfUrl,
  loadingPdf = false,
  notTimer = false, // default to false if not passed
  notice = "Please review the document carefully before continuing.",
  iframeTitle = "PDF Viewer",
}) {
  // const [timer, setTimer] = useState(180);
  // const [canClose, setCanClose] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isOpen);
  }, [isOpen]);

  // Handle modal open logic
  // useEffect(() => {
  //   if (typeof window === "undefined") return;

  //   const wasOpen = localStorage.getItem("pdfModalWasOpen") === "true";
  //   const storedTime = localStorage.getItem("pdfModalTimer");
  //   const storedStartTime = localStorage.getItem("pdfModalStartTime");

  //   if (notTimer) {
  //     setVisible(isOpen);
  //     return;
  //   }

  //   if (isOpen || wasOpen) {
  //     if (storedTime && storedStartTime) {
  //       const elapsed = Math.floor(
  //         (Date.now() - parseInt(storedStartTime, 10)) / 1000
  //       );
  //       const total = parseInt(storedTime, 10);
  //       const remaining = total - elapsed;

  //       if (remaining > 0) {
  //         setTimer(remaining);
  //         setCanClose(false);
  //         setVisible(true); // ✅ REOPEN modal since time is left
  //         localStorage.setItem("pdfModalWasOpen", "true");
  //       } else {
  //         // ❌ Don't reopen if timer expired
  //         setTimer(0);
  //         setCanClose(true);
  //         setVisible(false);
  //         localStorage.removeItem("pdfModalWasOpen");
  //         localStorage.removeItem("pdfModalTimer");
  //         localStorage.removeItem("pdfModalStartTime");
  //       }
  //     } else {
  //       // First time opening
  //       const freshStart = 180;
  //       setTimer(freshStart);
  //       setCanClose(false);
  //       setVisible(true);
  //       localStorage.setItem("pdfModalWasOpen", "true");
  //       localStorage.setItem("pdfModalTimer", freshStart.toString());
  //       localStorage.setItem("pdfModalStartTime", Date.now().toString());
  //     }
  //   } else {
  //     setVisible(false);
  //   }
  // }, [isOpen, notTimer]);

  // // Countdown effect
  // useEffect(() => {
  //   if (notTimer || !visible || timer <= 0) return;

  //   const interval = setInterval(() => {
  //     setTimer((prev) => {
  //       const updated = prev - 1;
  //       localStorage.setItem("pdfModalTimer", updated.toString());
  //       return updated;
  //     });
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [visible, timer, notTimer]);

  // // Timer ends
  // useEffect(() => {
  //   if (notTimer || timer !== 0) return;

  //   setCanClose(true);
  //   localStorage.removeItem("pdfModalTimer");
  //   localStorage.removeItem("pdfModalStartTime");
  // }, [timer, notTimer]);

  const handleClose = () => {
    if (!notTimer) {
      localStorage.removeItem("pdfModalTimer");
      localStorage.removeItem("pdfModalStartTime");
      localStorage.setItem("pdfModalWasOpen", "false");
    }

    setVisible(false);
    onClose?.();
  };

  // const formatTime = (seconds) => {
  //   const m = Math.floor(seconds / 60)
  //     .toString()
  //     .padStart(2, "0");
  //   const s = (seconds % 60).toString().padStart(2, "0");
  //   return `${m}:${s}`;
  // };

  return (
    // <Modal
    //   open={visible}
    //   onCancel={canClose || notTimer ? handleClose : undefined}
    //   closable={canClose || notTimer}
    //   footer={canClose || notTimer ? children : <div className="pb-4"></div>}
    //   width={1000}
    //   bodyStyle={pdfUrl ? { height: "80vh", padding: 0 } : {}}
    //   centered
    //   destroyOnClose
    //   maskClosable={canClose || notTimer}
    // >
    <Modal
      open={visible}
      onCancel={handleClose}
      closable={true}
      footer={children}
      width={1000}
      bodyStyle={pdfUrl || loadingPdf ? { height: "80vh", padding: 0 } : {}}
      centered
      destroyOnClose
      maskClosable={true}
    >
      <div style={{ backgroundColor: "#fff", width: "100%", height: "93%" }}>
        <h3 className="text-center font-bold text-2xl color-primary border-none border-l-0">
          {title}
        </h3>

        {notice ? (
          <div className="text-center text-red-600 font-semibold py-2">
            {notice}
          </div>
        ) : null}
        {loadingPdf && (
          <div className="flex justify-center items-center h-[70vh]">
            <Spin size="large" />
          </div>
        )}

        {!loadingPdf && pdfUrl && (
          <iframe
            src={`${pdfUrl}#navpanes=0&toolbar=0&statusbar=0&view=FitH`}
            title={iframeTitle}
            width="100%"
            height="100%"
            style={{
              border: "none",
              backgroundColor: "#fff",
              display: "block",
            }}
          />
        )}
      </div>
    </Modal>
  );
}
